"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let CreateContractRevision = class CreateContractRevision extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "page",
    };
    beforeCreate() {
        this.$$cache_options = new core_1.ComponentValueCache(this, "options", "CreateContractRevision.createRevisionOptions");
    }
    contract;
    onContract(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("contract");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formName;
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    labelAlign;
    item;
    async $$load_item() {
        return {
            id: this.contract.id,
            base_revision_id: this.contract.revision_id,
            revision_number: this.contract.revision_number + 1,
            revision_date: this.$fn.today(),
            valid_from: this.contract.lifecycle.valid_to ? this.$fn.dateAdd(this.contract.lifecycle.valid_to, { days: 1 }) : this.$fn.today(),
            valid_to: null,
            status: 'draft'
        };
    }
    statuses;
    async $$load_statuses() {
        return this.$fn.getEnumValuesFromSchema('ContractStatus');
    }
    options;
    ux;
    b_7315092382398562_modalBindings;
    dataMembers = ['formName', 'formId', 'labelAlign', 'item', 'statuses', 'options', 'ux', 'b_7315092382398562_modalBindings'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formName: "contract",
                formId: null,
                labelAlign: "right",
                item: null,
                statuses: null,
                options: {
                    copy_services: true,
                    copy_service_fees: true,
                    skip_outdated_services: true,
                    skip_outdated_service_fees: true,
                },
                ux: null,
                b_7315092382398562_modalBindings: {
                    size: "md",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Create Contract Revision"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_2844_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_1548630417156826_reloadSlickgrid_2850_getActionArgs($event) {
        return {
            grid: "contracts",
        };
    }
    async act_1548630417156826_closeComponent_2852_getActionArgs($event) {
        return {
            result: {
                close: true,
                value: $event.data.response.data,
            },
        };
    }
    async act_1548630417156826_navigate_2854_getActionArgs($event) {
        return {
            location: {
                name: "app.contract",
                params: {
                    id: $event.data.response.data.id,
                    rev: $event.data.response.data.revision_number,
                },
            },
        };
    }
    async act_1548630417156826_request_2848_getActionArgs($event) {
        return {
            operation: "create_contract_revision",
            data: { ...this.item, ...this.options },
        };
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1419464017721962_clickPreventStop(event, scope) {
        return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_2844 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_2844_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_2843 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_2844,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_2843],
        });
        const act_2248226175642056_closeComponent_2846 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_2845 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_2846,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_2845],
        });
        const act_1548630417156826_reloadSlickgrid_2850 = new core_1.actions.ReloadSlickgridAction({
            actionArgs: this.act_1548630417156826_reloadSlickgrid_2850_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_2849 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_reloadSlickgrid_2850,
            event: "success",
            displayName: "reloadSlickgrid",
        });
        const act_1548630417156826_closeComponent_2852 = new core_1.actions.CloseComponentAction({
            actionArgs: this.act_1548630417156826_closeComponent_2852_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_2851 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_2852,
            event: "success",
            displayName: "closeComponent",
        });
        const act_1548630417156826_navigate_2854 = new core_1.actions.NavigateAction({
            actionArgs: this.act_1548630417156826_navigate_2854_getActionArgs,
            events: [],
        });
        const evh_1548630417156826_success_2853 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_navigate_2854,
            event: "success",
            displayName: "navigate",
        });
        const act_1548630417156826_request_2848 = new core_1.actions.RequestAction({
            actionArgs: this.act_1548630417156826_request_2848_getActionArgs,
            displayName: "save",
            events: [evh_1548630417156826_success_2849, evh_1548630417156826_success_2851, evh_1548630417156826_success_2853],
        });
        const evh_1548630417156826_clickPreventStop_2847 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_request_2848,
            event: "click.prevent.stop",
            displayName: "save",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_2847],
        });
        const act_1419464017721962_closeModal_2856 = new core_1.actions.CloseModalAction({
            events: [],
        });
        const evh_1419464017721962_clickPreventStop_2855 = new core_1.actions.EventHandlerImpl({
            action: act_1419464017721962_closeModal_2856,
            event: "click.prevent.stop",
            displayName: "closeModal",
        });
        const evh_1419464017721962_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1419464017721962_clickPreventStop_2855],
        });
        return {
            act_7315092382398562_closeModal_2844,
            evh_7315092382398562_close_2843,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_2846,
            evh_2248226175642056_close_2845,
            evh_2248226175642056_close,
            act_1548630417156826_reloadSlickgrid_2850,
            evh_1548630417156826_success_2849,
            act_1548630417156826_closeComponent_2852,
            evh_1548630417156826_success_2851,
            act_1548630417156826_navigate_2854,
            evh_1548630417156826_success_2853,
            act_1548630417156826_request_2848,
            evh_1548630417156826_clickPreventStop_2847,
            evh_1548630417156826_clickPreventStop,
            act_1419464017721962_closeModal_2856,
            evh_1419464017721962_clickPreventStop_2855,
            evh_1419464017721962_clickPreventStop,
            save: act_1548630417156826_request_2848,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
        type: Object,
    }),
    __metadata("design:type", Object)
], CreateContractRevision.prototype, "contract", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('contract'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateContractRevision.prototype, "onContract", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], CreateContractRevision.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], CreateContractRevision.prototype, "onSize", null);
CreateContractRevision = __decorate([
    (0, vue_property_decorator_1.Component)()
], CreateContractRevision);
exports.default = CreateContractRevision;
vue_property_decorator_1.Vue.component("CreateContractRevision", CreateContractRevision);
